export const scorm = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16.4" height="13.463" viewBox="0 0 16.4 13.463">

    <g id="Group_27230" data-name="Group 27230" transform="translate(-84.3 -925.3)">

      <g id="archive" transform="translate(84 923)">

        <path id="Path_49132" data-name="Path 49132" d="M15.063,8v8.712H3V8" transform="translate(-0.66 -1.649)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4" />

        <rect id="Rectangle_11637" data-name="Rectangle 11637" width="15" height="3" transform="translate(1 3)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4" />

        <line id="Line_1629" data-name="Line 1629" x2="3" transform="translate(7 9)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4" />

      </g>

    </g>

  </svg>
);

export const dashboard = (
  <svg
    width={15}
    height={21}
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.961 19.54V1.56M1.968 19.54V5.555M13.953 19.54v-6.992"
      stroke="#444850"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const products = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.25"
    height="14.252"
    viewBox="0 0 14.25 14.252"
  >
    <path
      id="columns"
      d="M9.426,3h5a1.428,1.428,0,0,1,1.428,1.428v10a1.428,1.428,0,0,1-1.428,1.428h-5M9.426,3h-5A1.428,1.428,0,0,0,3,4.428v10a1.428,1.428,0,0,0,1.428,1.428h5M9.426,3V15.852"
      transform="translate(-2.301 -2.3)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const users = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.107"
    height="14.675"
    viewBox="0 0 18.107 14.675"
  >
    <g id="users" transform="translate(0.7 0.7)">
      <path
        id="Path_21711"
        data-name="Path 21711"
        d="M12.424,19.284V17.856A2.856,2.856,0,0,0,9.568,15H3.856A2.856,2.856,0,0,0,1,17.856v1.428"
        transform="translate(-1 -6.009)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <ellipse
        id="Ellipse_246"
        data-name="Ellipse 246"
        cx="2.992"
        cy="2.99"
        rx="2.992"
        ry="2.99"
        transform="translate(2.963 0)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21712"
        data-name="Path 21712"
        d="M22.142,19.321V17.893A2.856,2.856,0,0,0,20,15.13"
        transform="translate(-5.434 -6.139)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21713"
        data-name="Path 21713"
        d="M16,3.13a2.856,2.856,0,0,1,0,5.533"
        transform="translate(-4.29 -2.707)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const manage = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.049"
    height="15.184"
    viewBox="0 0 15.049 15.184"
  >
    <path
      id="tool"
      d="M11.353,5.069a.714.714,0,0,0,0,1L12.5,7.211a.714.714,0,0,0,1,0l2.692-2.692a4.284,4.284,0,0,1-5.669,5.669L5.584,15.122A1.515,1.515,0,0,1,3.442,12.98L8.376,8.046a4.284,4.284,0,0,1,5.669-5.669L11.36,5.062Z"
      transform="translate(-2.299 -1.216)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const reports = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.715"
    height="15.705"
    viewBox="0 0 15.715 15.705"
  >
    <g id="pie-chart" transform="translate(0.734 0.7)">
      <path
        id="Path_21721"
        data-name="Path 21721"
        d="M15.715,12.155A7.14,7.14,0,1,1,6.284,2.83"
        transform="translate(-1.999 -2.237)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21722"
        data-name="Path 21722"
        d="M19.14,9.14A7.14,7.14,0,0,0,12,2V9.14Z"
        transform="translate(-4.86 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const subscriptions = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.895"
    height="14.445"
    viewBox="0 0 15.895 14.445"
  >
    <path
      id="Registrations"
      d="M16.494,9.522H13.6l-2.174,6.522L7.073,3,4.9,9.522H2"
      transform="translate(-1.3 -2.3)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const mysubscriptions = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.7"
    height="15.468"
    viewBox="0 0 15.7 15.468"
  >
    <g id="check-circle" transform="translate(0.884 0.847)">
      <path
        id="Path_21716"
        data-name="Path 21716"
        d="M15.826,8.275v.636a6.913,6.913,0,1,1-4.1-6.318"
        transform="translate(-2 -1.994)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21717"
        data-name="Path 21717"
        d="M17.987,4l-6.913,6.92L9,8.846"
        transform="translate(-4.161 -2.613)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const marketing = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.688"
    height="10.548"
    viewBox="0 0 17.688 10.548"
  >
    <g id="trending-up" transform="translate(0.99 0.99)">
      <path
        id="Path_21719"
        data-name="Path 21719"
        d="M16.707,6,9.925,12.783l-3.57-3.57L1,14.568"
        transform="translate(-1 -6)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21720"
        data-name="Path 21720"
        d="M17,6h4.284v4.284"
        transform="translate(-5.576 -6)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const website = (
  <svg
    className="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="15.639"
    height="14.217"
    viewBox="0 0 15.639 14.217"
  >
    <g
      transform="translate(.219 .7)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    >
      <rect
        data-name="Rectangle 1574"
        width="14.24"
        height="9.68"
        rx={1}
        transform="translate(.48)"
      />
      <path data-name="Line 772" d="M4.98 12.816h5" />
      <path data-name="Line 773" d="M7.479 9.65v3.165" />
    </g>
  </svg>
);

export const settings = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.526 15.162C14.459 15.162 16.026 13.8188 16.026 12.162C16.026 10.5051 14.459 9.16199 12.526 9.16199C10.593 9.16199 9.026 10.5051 9.026 12.162C9.026 13.8188 10.593 15.162 12.526 15.162Z"
      stroke="#444850"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.377 14.983C19.2441 15.2843 19.2044 15.6186 19.2633 15.9426C19.3221 16.2666 19.4766 16.5656 19.707 16.801L19.767 16.861C19.9654 17.0436 20.1248 17.2644 20.2357 17.5102C20.3465 17.7559 20.4066 18.0216 20.4121 18.2911C20.4177 18.5607 20.3688 18.8286 20.2682 19.0788C20.1676 19.3289 20.0174 19.5561 19.8268 19.7468C19.6361 19.9374 19.4089 20.0876 19.1588 20.1882C18.9086 20.2888 18.6407 20.3377 18.3711 20.3321C18.1016 20.3266 17.8359 20.2665 17.5902 20.1557C17.3444 20.0448 17.1236 19.8854 16.941 19.687L16.881 19.627C16.6475 19.401 16.3528 19.2485 16.0335 19.1884C15.7142 19.1282 15.3842 19.163 15.0845 19.2885C14.7847 19.414 14.5284 19.6246 14.3472 19.8944C14.166 20.1641 14.0679 20.4811 14.065 20.806V20.976C14.065 21.5064 13.8543 22.0151 13.4792 22.3902C13.1041 22.7653 12.5954 22.976 12.065 22.976C11.5346 22.976 11.0259 22.7653 10.6508 22.3902C10.2757 22.0151 10.065 21.5064 10.065 20.976V20.886C10.0577 20.5557 9.95133 20.2352 9.75963 19.9661C9.56794 19.697 9.2998 19.4918 8.99 19.377C8.68869 19.2441 8.35445 19.2044 8.0304 19.2633C7.70636 19.3221 7.40737 19.4766 7.172 19.707L7.112 19.767C6.929 19.964 6.70817 20.122 6.4627 20.2317C6.21723 20.3414 5.95217 20.4004 5.68336 20.4054C5.41454 20.4103 5.1475 20.3609 4.89819 20.2603C4.64887 20.1597 4.42241 20.0098 4.23233 19.8196C4.04225 19.6295 3.89247 19.403 3.79192 19.1536C3.69137 18.9043 3.64213 18.6372 3.64714 18.3684C3.65215 18.0996 3.71131 17.8346 3.82108 17.5891C3.93084 17.3437 4.08897 17.1229 4.286 16.94L4.346 16.88C4.57197 16.6465 4.72448 16.3518 4.78465 16.0325C4.84482 15.7132 4.81 15.3832 4.68451 15.0835C4.55901 14.7837 4.34836 14.5274 4.07863 14.3462C3.80889 14.165 3.49193 14.0669 3.167 14.064H3C2.46957 14.064 1.96086 13.8533 1.58579 13.4782C1.21071 13.1031 1 12.5944 1 12.064C1 11.5336 1.21071 11.0249 1.58579 10.6498C1.96086 10.2747 2.46957 10.064 3 10.064H3.09C3.42035 10.057 3.74098 9.95084 4.01024 9.75932C4.27951 9.56781 4.48499 9.29977 4.6 8.99C4.73295 8.68869 4.77257 8.35445 4.71375 8.0304C4.65493 7.70636 4.50037 7.40737 4.27 7.172L4.21 7.112C4.00704 6.93083 3.84317 6.71015 3.72843 6.46346C3.61369 6.21678 3.55048 5.94928 3.54268 5.67733C3.53488 5.40538 3.58264 5.13469 3.68305 4.88184C3.78346 4.62898 3.9344 4.39927 4.12664 4.20676C4.31888 4.01424 4.54838 3.86297 4.80109 3.76221C5.05381 3.66144 5.32442 3.61329 5.59639 3.62071C5.86835 3.62813 6.13594 3.69096 6.38278 3.80535C6.62963 3.91974 6.85054 4.08329 7.032 4.286L7.092 4.346C7.32737 4.57637 7.62636 4.73093 7.9504 4.78975C8.27445 4.84857 8.60869 4.80895 8.91 4.676H8.99C9.28561 4.54959 9.53779 4.33946 9.71547 4.07152C9.89316 3.80357 9.98858 3.4895 9.99 3.168V3C9.99 2.46957 10.2007 1.96086 10.5758 1.58579C10.9509 1.21071 11.4596 1 11.99 1C12.5204 1 13.0291 1.21071 13.4042 1.58579C13.7793 1.96086 13.99 2.46957 13.99 3V3.09C13.9945 3.41348 14.0934 3.72859 14.2746 3.99665C14.4557 4.2647 14.7112 4.47402 15.0096 4.59892C15.308 4.72381 15.6364 4.75884 15.9545 4.6997C16.2725 4.64056 16.5664 4.48982 16.8 4.266L16.86 4.206C17.0426 4.00762 17.2634 3.8482 17.5092 3.73734C17.7549 3.62647 18.0206 3.56644 18.2901 3.56085C18.5597 3.55527 18.8276 3.60425 19.0778 3.70484C19.3279 3.80543 19.5551 3.95556 19.7458 4.14621C19.9364 4.33686 20.0866 4.56409 20.1872 4.81424C20.2878 5.06439 20.3367 5.33229 20.3311 5.60185C20.3256 5.87141 20.2655 6.13706 20.1547 6.38283C20.0438 6.6286 19.8844 6.84941 19.686 7.032L19.626 7.092C19.3963 7.32781 19.2425 7.62701 19.1844 7.95104C19.1263 8.27507 19.1665 8.60907 19.3 8.91V8.99C19.4264 9.28561 19.6365 9.53779 19.9045 9.71547C20.1724 9.89316 20.4865 9.98858 20.808 9.99H20.978C21.5084 9.99 22.0171 10.2007 22.3922 10.5758C22.7673 10.9509 22.978 11.4596 22.978 11.99C22.978 12.5204 22.7673 13.0291 22.3922 13.4042C22.0171 13.7793 21.5084 13.99 20.978 13.99H20.888C20.5668 13.9902 20.2526 14.0844 19.9842 14.2608C19.7157 14.4372 19.5047 14.6882 19.377 14.983V14.983Z"
      stroke="#444850"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const documents = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.031}
    height={12.189}
    viewBox="0 0 10.031 12.189"
  >
    <g fill="none" stroke="#76777a" strokeWidth={1.4}>
      <path
        data-name="Path 21658"
        d="M4.855 0H1.079A1.079 1.079 0 000 1.079V9.71a1.079 1.079 0 001.079 1.079h6.474A1.079 1.079 0 008.632 9.71V3.776z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 21659"
        d="M4.855 0v3.776h3.776"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
)

export const file = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.822"
    height="15.68"
    viewBox="0 0 12.822 15.68"
  >
    <g id="file" transform="translate(0.699 0.7)">
      <path
        id="Path_21714"
        data-name="Path 21714"
        d="M10.426,2h-5A1.428,1.428,0,0,0,4,3.428V14.852a1.428,1.428,0,0,0,1.428,1.428H14a1.428,1.428,0,0,0,1.428-1.428V7Z"
        transform="translate(-4 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21715"
        data-name="Path 21715"
        d="M13,2V7h5"
        transform="translate(-6.574 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const leftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5.241"
    height="11.265"
    viewBox="0 0 5.241 11.265"
  >
    <path
      id="Path_41"
      data-name="Path 41"
      d="M7212.063-9151.6l-3.56,4.65,3.56,4.651"
      transform="translate(-7207.804 9152.58)"
      fill="none"
      stroke="#acacb0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const externalLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.822"
    height="13.535"
    viewBox="0 0 13.822 13.535"
  >
    <g id="external-link" transform="translate(0.699 0.035)">
      <path
        id="Path_21436"
        data-name="Path 21436"
        d="M13.667,10.978v4.267a1.422,1.422,0,0,1-1.422,1.422H4.422A1.422,1.422,0,0,1,3,15.244V7.422A1.422,1.422,0,0,1,4.422,6H8.689"
        transform="translate(-3 -3.867)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21437"
        data-name="Path 21437"
        d="M15,3h3.361V6.36"
        transform="translate(-6.115 -2.253)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <line
        id="Line_123"
        data-name="Line 123"
        y1={7}
        x2={7}
        transform="translate(5.133 0.955)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const superadminIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-app-indicator"
    viewBox="0 0 16 16"
  >
    <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
    <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
  </svg>
);

export const profileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-person"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
  </svg>
);

export const settingsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-gear"
    viewBox="0 0 16 16"
  >
    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
  </svg>
);

export const logoutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box-arrow-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
    />
    <path
      fillRule="evenodd"
      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
    />
  </svg>
);

export const moonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-moon"
    viewBox="0 0 16 16"
  >
    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
  </svg>
);

export const shield = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.326"
    height="17.558"
    viewBox="0 0 14.326 17.558"
  >
    <path
      id="Icon_feather-shield"
      data-name="Icon feather-shield"
      d="M12.463,19.158s6.463-3.232,6.463-8.079V5.424L12.463,3,6,5.424v5.655C6,15.926,12.463,19.158,12.463,19.158Z"
      transform="translate(-5.3 -2.3)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const mykademyLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={150}
    height={32}
    className="d-block my-1"
    viewBox="0 0 9367.293 1486.342"
  >
    {" "}
    <g transform="translate(34 -312)">
      {" "}
      <g transform="translate(-34 312)">
        {" "}
        <g transform="translate(2255.718 89.226)">
          {" "}
          <path
            d="M506.1,425.869c0-68.6-9.147-114.334-27.441-146.347-18.293-27.44-45.733-41.16-91.467-41.16h-41.16c-13.72,0-27.44,4.573-41.16,4.573V819.178H94.5V101.16c18.294-4.573,41.16-9.147,64.027-13.72s50.307-9.147,77.747-13.72,54.88-9.147,82.32-9.147C346.035,60,373.475,60,400.915,60c54.88,0,96.041,4.573,132.628,18.294C565.556,92.014,593,110.307,615.864,128.6c32.013-22.867,64.027-36.587,105.187-50.307S794.225,60,830.812,60c59.454,0,109.76,9.147,146.347,22.867,36.587,18.294,68.6,41.16,91.467,68.6,22.867,32.013,36.587,64.027,45.733,109.76q13.72,61.741,13.72,137.2V819.178H917.706V425.869c0-68.6-9.147-114.334-27.44-146.347-18.293-27.44-45.733-41.16-91.467-41.16-9.147,0-27.44,4.573-45.734,9.146s-36.587,13.72-50.307,22.867q6.86,34.3,13.72,68.6c0,22.866,4.574,50.307,4.574,77.747V823.751H510.677V425.869Z"
            transform="translate(-94.5 278.429)"
            fill="currentColor"
          />{" "}
          <path
            d="M873.3,64.773c-41.16,141.774-86.893,278.975-132.627,402.456S644.637,714.19,589.757,833.1c-18.293,41.16-41.16,77.747-59.454,109.761s-41.16,54.88-64.027,73.174-50.307,32.013-82.321,41.161-64.027,13.72-105.187,13.72c-32.014,0-64.027-4.573-91.467-9.146s-50.307-13.72-68.6-18.294l36.587-169.214c22.867,9.147,41.16,13.72,59.454,13.72,18.294,4.573,36.587,4.573,54.88,4.573,36.587,0,68.6-9.147,86.894-32.013,18.293-18.294,36.587-50.307,50.307-82.321-50.307-96.041-96.041-201.228-146.348-320.135S169.007,206.548,123.274,60.2H347.368c9.147,36.587,22.867,77.747,32.014,118.907,13.72,41.16,27.44,86.894,41.16,132.627s27.44,86.894,41.16,128.054,27.44,77.747,41.16,114.334c13.72-32.013,22.867-73.174,36.587-114.334s27.44-82.321,41.16-128.054,22.867-86.894,36.587-132.627c13.72-41.16,22.867-82.321,32.013-118.907H873.3Z"
            transform="translate(988.053 287.376)"
            fill="currentColor"
          />{" "}
          <path
            d="M348.076,674.577c22.867-22.867,41.16-45.734,64.027-68.6S457.837,555.67,476.13,532.8c22.867-22.867,41.16-45.734,59.454-68.6s32.013-41.16,45.733-54.88H832.852C782.545,468.776,732.238,523.656,686.5,573.963S585.891,679.15,531.011,734.031c27.44,27.44,59.454,54.88,86.894,91.467,32.013,36.587,59.454,73.174,86.893,109.761s54.88,77.747,77.747,114.334S828.279,1122.766,842,1154.78H599.61c-13.72-22.867-32.013-50.307-50.307-82.321s-41.16-59.454-59.454-91.467-45.734-59.454-68.6-86.894-45.734-50.307-73.174-68.6v324.708H137.7V84.613L348.075,52.6V674.577Z"
            transform="translate(1837.99 -52.6)"
            fill="currentColor"
          />{" "}
          <path
            d="M474.335,59.9c64.027,0,114.334,9.147,155.494,22.867S703,119.354,730.443,142.221q34.3,41.16,54.88,96.04c9.147,36.587,13.72,77.747,13.72,128.054V805.357c-32.013,4.573-73.174,13.72-128.054,22.867s-118.908,13.72-196.655,13.72c-50.307,0-91.467-4.573-132.627-13.72s-73.174-22.867-100.614-41.16-50.307-45.734-64.027-77.747S154.2,640.717,154.2,594.983s9.146-82.321,27.44-109.761c18.294-32.013,41.16-54.88,68.6-73.174s64.026-32.014,100.614-41.16,77.747-13.72,118.907-13.72c27.441,0,50.308,0,73.175,4.573s36.587,4.573,50.307,9.147V352.594c0-36.587-9.147-64.027-32.014-86.894S501.776,233.687,446.9,233.687c-36.587,0-73.174,4.573-105.187,9.147-36.587,4.573-64.027,13.72-91.467,22.867L222.8,96.486c13.72-4.573,27.441-9.147,45.734-13.72s36.587-9.147,59.454-9.147c22.867-4.573,45.734-4.573,68.6-9.147C424.029,59.9,446.895,59.9,474.335,59.9Zm18.294,617.4h59.454c18.293,0,32.013-4.573,45.733-4.573V512.663c-9.146,0-22.867-4.573-36.587-4.573-18.293,0-32.013-4.573-45.734-4.573-18.293,0-36.586,0-54.88,4.573s-32.013,9.147-45.734,13.72-22.867,13.72-32.013,27.44c-9.146,9.147-9.146,27.44-9.146,41.16,0,32.013,9.146,54.88,32.013,68.6C419.455,668.157,451.468,677.3,492.629,677.3Z"
            transform="translate(2576.096 273.955)"
            fill="currentColor"
          />{" "}
          <path
            d="M871.324,1127.339c-18.293,4.573-41.16,9.147-64.026,18.294-22.867,4.573-50.308,9.147-77.747,13.72s-54.881,4.573-82.321,9.147-54.88,4.573-82.321,4.573q-89.18,0-164.641-27.44c-50.307-18.294-86.893-45.734-123.481-77.747-32.013-32.014-59.453-73.174-77.747-123.481-18.293-45.734-27.44-100.614-27.44-160.068S180.746,670,194.467,619.7s36.586-91.467,64.027-123.481,64.026-59.454,105.187-77.747,86.894-27.44,141.775-27.44c27.44,0,54.88,4.573,77.747,9.147s45.733,13.72,68.6,22.867V84.614L862.178,52.6V1127.339Zm-480.2-356.722c0,64.027,13.72,118.907,45.734,155.494s73.174,59.454,132.627,59.454h50.307c18.294,0,27.441-4.573,41.16-4.573V596.83c-13.72-9.146-32.013-13.72-50.308-22.867-22.867-4.573-41.159-9.147-64.026-9.147C441.428,569.39,391.121,633.417,391.121,770.617Z"
            transform="translate(3354.46 -52.6)"
            fill="currentColor"
          />{" "}
          <path
            d="M190.4,457.782c0-64.027,9.147-123.48,32.013-173.788q27.439-75.46,82.32-123.481C336.747,128.5,377.908,101.06,419.068,87.34c41.16-18.293,86.893-27.44,132.627-27.44,105.188,0,187.508,32.014,251.536,96.041C862.683,219.968,894.7,316.008,894.7,439.489v41.16c0,13.72,0,27.44-4.574,41.16H409.92c4.574,45.734,22.867,77.747,59.454,105.187s82.32,36.587,146.348,36.587c36.586,0,77.747-4.573,114.333-9.147s68.6-13.72,91.467-27.44l27.441,173.788c-9.146,4.573-27.441,9.146-45.733,18.293-18.294,4.574-41.161,9.147-64.027,13.72s-45.733,9.146-73.174,9.146c-27.44,4.573-54.88,4.573-77.747,4.573-68.6,0-123.481-9.146-173.787-32.013q-75.462-27.44-123.481-82.321C259,695.6,236.134,659.011,217.839,608.7S190.4,512.663,190.4,457.782Zm498.5-82.32c0-18.293-4.574-36.587-9.146-50.307s-13.72-32.014-22.867-45.734-22.867-22.867-41.161-32.013-36.586-13.72-59.453-13.72-45.734,4.573-59.454,13.72c-18.293,9.147-32.013,18.293-41.16,32.013s-18.294,27.44-27.441,45.734q-6.86,27.44-13.72,54.88H688.9Z"
            transform="translate(4195.452 273.955)"
            fill="currentColor"
          />{" "}
          <path
            d="M620.9,425.869c0-68.6-9.146-114.334-27.44-146.347-18.293-27.44-45.734-41.16-91.467-41.16h-41.16c-13.72,0-27.441,4.573-41.16,4.573V819.178H209.3V101.16c18.294-4.573,41.161-9.147,64.026-13.72s50.308-9.147,77.748-13.72,54.88-9.147,82.32-9.147C460.835,60,488.274,60,515.715,60c54.88,0,96.041,4.573,132.627,18.294S707.8,110.307,730.663,128.6c32.013-22.867,64.026-36.587,105.187-50.307S909.024,60,945.611,60c59.454,0,109.761,9.147,146.347,22.867,36.587,18.294,68.6,41.16,91.468,68.6s36.588,64.027,45.734,109.76q13.72,61.741,13.72,137.2V819.178H1032.5V425.869c0-68.6-9.148-114.334-27.441-146.347-18.293-27.44-45.734-41.16-91.468-41.16-9.147,0-27.44,4.573-45.733,9.146s-36.586,13.72-50.307,22.867q6.862,34.3,13.721,68.6c0,22.866,4.573,50.307,4.573,77.747V823.751H625.475V425.869Z"
            transform="translate(5040.917 278.429)"
            fill="currentColor"
          />{" "}
          <path
            d="M988.1,64.773c-41.16,141.774-86.894,278.975-132.628,402.456S759.437,714.19,704.556,833.1c-18.294,41.16-41.16,77.747-59.454,109.761s-41.16,54.88-64.026,73.174-50.307,32.013-82.321,41.161-64.027,13.72-105.187,13.72c-32.013,0-64.027-4.573-91.467-9.146s-50.307-13.72-68.6-18.294l36.587-169.214c22.867,9.147,41.16,13.72,59.453,13.72,18.293,4.573,36.587,4.573,54.881,4.573,36.586,0,68.6-9.147,86.893-32.013,18.293-18.294,36.588-50.307,50.307-82.321-50.307-96.041-96.04-201.228-146.347-320.135S283.808,206.548,238.074,60.2H462.168c9.146,36.587,22.866,77.747,32.013,118.907,13.721,41.16,27.44,86.894,41.16,132.627s27.441,86.894,41.16,128.054,27.44,77.747,41.16,114.334c13.72-32.013,22.867-73.174,36.587-114.334s27.44-82.321,41.16-128.054S722.848,224.841,732,179.107c13.719-41.16,22.866-82.321,32.013-118.907H988.1Z"
            transform="translate(6123.47 287.376)"
            fill="currentColor"
          />{" "}
        </g>{" "}
        <g transform="translate(0)">
          {" "}
          <g transform="translate(1984.838) rotate(90)">
            {" "}
            <path
              d="M114.334,109.761,429.9,0V1102.18c0,73.174-45.734,137.2-114.334,164.641L0,1376.582V274.4c4.573-73.174,45.733-137.2,114.334-164.641"
              transform="translate(0 352.149)"
              fill="#64caa1"
            />{" "}
            <path
              d="M114.334,109.761,429.9,0V1102.18c0,73.174-45.734,137.2-114.334,164.641L0,1376.581V274.4c4.573-73.174,50.307-137.2,114.334-164.641"
              transform="translate(1056.446 256.108)"
              fill="#64caa1"
            />{" "}
            <path
              d="M0,0"
              transform="translate(320.135 818.631)"
              fill="#148f84"
            />{" "}
            <path
              d="M114.334,109.761,429.9,0V1710.437c0,73.174-45.734,137.2-114.334,164.641L0,1984.838V274.4c0-73.174,45.734-137.2,114.334-164.641"
              transform="translate(530.51)"
              fill="#64caa1"
            />{" "}
            <path
              d="M0,0Z"
              transform="translate(635.697 772.898)"
              fill="#148f84"
              fillRule="evenodd"
            />{" "}
          </g>{" "}
        </g>{" "}
      </g>{" "}
    </g>{" "}
  </svg>
);

export const mykademySquareDarkLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={15.71}
    viewBox="0 0 21 15.71"
  >
    <g fill="#272535">
      <path
        d="M1.2 1.135L4.518 0v11.646a1.926 1.926 0 01-1.2 1.748L0 14.53V2.86a1.919 1.919 0 011.2-1.725"
        transform="rotate(90 10.5 10.5) translate(0 3.769)"
      />
      <path
        d="M1.2 1.135L4.518 0v11.646a1.926 1.926 0 01-1.2 1.748L0 14.53V2.883a2 2 0 011.2-1.748"
        transform="rotate(90 10.5 10.5) translate(11.193 2.724)"
      />
      <path
        d="M1.2 1.135L4.518 0v18.117a1.925 1.925 0 01-1.2 1.748L0 21V2.883a2.027 2.027 0 011.2-1.748"
        transform="rotate(90 10.5 10.5) translate(5.585)"
      />
    </g>
  </svg>
);

export const viewLiveSiteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="currentColor"
    className="bi bi-box-arrow-up-right"
    viewBox="0 0 16 16"
  >
    {" "}
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />{" "}
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />{" "}
  </svg>
);

export const helpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-question-circle"
    viewBox="0 0 16 16"
  >
    {" "}
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />{" "}
    <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />{" "}
  </svg>
);

export const bellIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="15.62"
    viewBox="0 0 14.2 15.62"
  >
    {" "}
    <g id="bell" transform="translate(0.7 0.7)">
      {" "}
      <path
        id="Path_21414"
        data-name="Path 21414"
        d="M13.667,6.267a4.267,4.267,0,1,0-8.533,0c0,4.978-2.133,6.4-2.133,6.4H15.8s-2.133-1.422-2.133-6.4"
        transform="translate(-3 -2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
      <path
        id="Path_21415"
        data-name="Path 21415"
        d="M12.73,21a1.422,1.422,0,0,1-2.46,0"
        transform="translate(-5.1 -7.489)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
    </g>{" "}
  </svg>
);

export const chatIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="14.2"
    viewBox="0 0 14.2 14.2"
  >
    {" "}
    <path
      id="message-square"
      d="M15.8,11.533a1.422,1.422,0,0,1-1.422,1.422H5.844L3,15.8V4.422A1.422,1.422,0,0,1,4.422,3h9.956A1.422,1.422,0,0,1,15.8,4.422Z"
      transform="translate(-2.3 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />{" "}
  </svg>
);

export const rightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.718"
    height="4.631"
    viewBox="0 0 9.718 4.631"
  >
    {" "}
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />{" "}
  </svg>
);

export const cubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-grid-3x3-gap"
    viewBox="0 0 16 16"
  >
    {" "}
    <path d="M4 2v2H2V2h2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z" />{" "}
  </svg>
);

export const togglerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.2"
    height="20.2"
    viewBox="0 0 20.2 20.2"
  >
    <g
      id="Group_18767"
      data-name="Group 18767"
      transform="translate(-1619.701 -31.699)"
    >
      <g id="more-horizontal" transform="translate(1620.301 32.3)">
        <circle
          id="Ellipse_263"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g
        id="more-horizontal-2"
        data-name="more-horizontal"
        transform="translate(1620.301 40.123)"
      >
        <circle
          id="Ellipse_263-2"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264-2"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265-2"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g
        id="more-horizontal-3"
        data-name="more-horizontal"
        transform="translate(1620.301 47.948)"
      >
        <circle
          id="Ellipse_263-3"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264-3"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265-3"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </g>
  </svg>
);

export const downArrowBlue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6.119"
    height="11.658"
    viewBox="0 0 6.119 11.658"
  >
    <path
      id="Path_21616"
      data-name="Path 21616"
      d="M0,0,4.42,3.71,8.84,0"
      transform="translate(1.409 10.249) rotate(-90)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const calendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="#6f75bc"
    className="bi bi-calendar4"
    viewBox="0 0 16 16"
  >
    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z" />
  </svg>
);

export const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.831"
    height="15.665"
    viewBox="0 0 15.831 15.665"
  >
    <path
      id="edit-2"
      d="M12.791,2.768a2.035,2.035,0,1,1,2.878,2.878L5.957,15.357,2,16.437,3.079,12.48Z"
      transform="translate(-1.3 -1.472)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const binIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.999"
    height="14.288"
    viewBox="0 0 12.999 14.288"
  >
    <g id="trash_1_" data-name="trash (1)" transform="translate(0.7 0.7)">
      <path
        id="Path_13"
        data-name="Path 13"
        d="M3,6H14.6"
        transform="translate(-3 -3.422)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_14"
        data-name="Path 14"
        d="M14.021,4.578V13.6a1.289,1.289,0,0,1-1.289,1.289H6.289A1.289,1.289,0,0,1,5,13.6V4.578m1.933,0V3.289A1.289,1.289,0,0,1,8.222,2H10.8a1.289,1.289,0,0,1,1.289,1.289V4.578"
        transform="translate(-3.711 -2)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const externalLinkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />
  </svg>
);

export const downloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.075"
    height="9.914"
    viewBox="0 0 9.075 9.914"
  >
    {" "}
    <g
      id="Icon_feather-download"
      data-name="Icon feather-download"
      transform="translate(-5.902 -3.8)"
    >
      {" "}
      <path
        id="Path_40557"
        data-name="Path 40557"
        d="M10.5,15l3.547,3.547L17.595,15"
        transform="translate(-3.608 -5.534)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
      <path
        id="Path_40558"
        data-name="Path 40558"
        d="M18,13.014V4.5"
        transform="translate(-7.56)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
    </g>{" "}
  </svg>
);

export const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.733"
    height="12.734"
    viewBox="0 0 12.733 12.734"
  >
    <g
      id="Icon_feather-copy"
      data-name="Icon feather-copy"
      transform="translate(-2.3 -2.3)"
    >
      <path
        id="Path_40559"
        data-name="Path 40559"
        d="M14.633,13.5h5.1a1.133,1.133,0,0,1,1.133,1.133v5.1a1.133,1.133,0,0,1-1.133,1.133h-5.1A1.133,1.133,0,0,1,13.5,19.733v-5.1A1.133,1.133,0,0,1,14.633,13.5Z"
        transform="translate(-6.533 -6.533)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_40560"
        data-name="Path 40560"
        d="M4.7,10.367H4.133A1.133,1.133,0,0,1,3,9.233v-5.1A1.133,1.133,0,0,1,4.133,3h5.1a1.133,1.133,0,0,1,1.133,1.133V4.7"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const menuHamburgerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.837"
    height="16.558"
    viewBox="0 0 23.837 16.558"
  >
    <g data-name="Icon feather-menu" transform="translate(-3.5 -8)">
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(0 -1.721)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40586"
        data-name="Path 40586"
        d="M4.5,9H26.337"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40587"
        data-name="Path 40587"
        d="M4.5,27H26.337"
        transform="translate(0 -3.442)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const menuCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.27"
    height="18.27"
    viewBox="0 0 18.27 18.27"
  >
    <g
      id="Icon_feather-menu"
      data-name="Icon feather-menu"
      transform="translate(-3.086 -7.144)"
    >
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(14.046 -7.351) rotate(45)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40588"
        data-name="Path 40588"
        d="M0,0H21.837"
        transform="translate(19.942 8.558) rotate(135)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const lockPadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.169"
    height="17.81"
    viewBox="0 0 16.169 17.81"
  >
    <g
      id="Icon_feather-lock"
      data-name="Icon feather-lock"
      transform="translate(-3.8 -2.3)"
    >
      <path
        id="Path_40549"
        data-name="Path 40549"
        d="M6.141,16.5H17.628a1.641,1.641,0,0,1,1.641,1.641v5.743a1.641,1.641,0,0,1-1.641,1.641H6.141A1.641,1.641,0,0,1,4.5,23.884V18.141A1.641,1.641,0,0,1,6.141,16.5Z"
        transform="translate(0 -6.116)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_40550"
        data-name="Path 40550"
        d="M10.5,10.384V7.1a4.1,4.1,0,1,1,8.2,0v3.282"
        transform="translate(-2.718)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-x"
    viewBox="0 0 16 16"
  >
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
  </svg>
);

export const closeIconBlue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="#6f75bc"
    className="bi bi-x-lg"
    viewBox="0 0 16 16"
  >
    <path d="M2.146 2.854a.5.5 0 11.708-.708L8 7.293l5.146-5.147a.5.5 0 01.708.708L8.707 8l5.147 5.146a.5.5 0 01-.708.708L8 8.707l-5.146 5.147a.5.5 0 01-.708-.708L7.293 8 2.146 2.854z" />
  </svg>
);

export const chervonDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={4}
    viewBox="0 0 9.718 4.631"
  >
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const removeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.763"
    height="7.763"
    viewBox="0 0 7.763 7.763"
  >
    <g data-name="Group 17821" transform="translate(0.99 0.99)">
      <path
        id="Path_21632"
        data-name="Path 21632"
        d="M0,0V8.177"
        transform="translate(5.783 0) rotate(45)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21633"
        data-name="Path 21633"
        d="M0,0V8.177"
        transform="translate(5.782 5.783) rotate(135)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const addIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.39"
    height="10.391"
    viewBox="0 0 10.39 10.391"
  >
    <g id="Group_17764" data-name="Group 17764" transform="translate(0.7 0.7)">
      <path
        id="Path_9"
        data-name="Path 9"
        d="M1756.344,206.134h-8.99"
        transform="translate(-1747.354 -201.864)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_32"
        data-name="Path 32"
        d="M8.991,0H0"
        transform="translate(4.495) rotate(90)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const toolIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.049"
    height="15.184"
    viewBox="0 0 15.049 15.184"
  >
    <path
      id="tool"
      d="M11.353,5.069a.714.714,0,0,0,0,1L12.5,7.211a.714.714,0,0,0,1,0l2.692-2.692a4.284,4.284,0,0,1-5.669,5.669L5.584,15.122A1.515,1.515,0,0,1,3.442,12.98L8.376,8.046a4.284,4.284,0,0,1,5.669-5.669L11.36,5.062Z"
      transform="translate(-2.299 -1.216)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.531}
    height={9.409}
    viewBox="0 0 4.531 9.409"
  >
    <path
      data-name="Path 40564"
      d="M2.85 0L0 3.723l2.85 3.725"
      transform="rotate(-90 3 4)"
      fill="none"
      stroke="#A3A6AC"
    />
  </svg>
);

export const upArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.531}
    height={9.409}
    viewBox="0 0 4.531 9.409"
  >
    <path
      data-name="Path 40564"
      d="M2.85 0L0 3.723l2.85 3.725"
      transform="rotate(90 1.5 4.5)"
      fill="none"
      stroke="#A3A6AC"
    />
  </svg>
);

export const calendarIcon101 = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ enableBackground: "new 0 0 512 512" }}
    xmlSpace="preserve"
    fill="currentColor"
  >
    <g>
      <path
        d="M93.1,69.8v23.3h325.8c12.8,0,23.2,10.4,23.3,23.3v325.8c0,12.8-10.4,23.2-23.3,23.3H93.1c-12.8,0-23.2-10.4-23.3-23.3
		V116.4c0-12.8,10.4-23.3,23.3-23.3V69.8V46.5c-38.6,0-69.8,31.2-69.8,69.8v325.8c0,38.6,31.2,69.8,69.8,69.8h325.8
		c38.6,0,69.8-31.2,69.8-69.8V116.4c0-38.6-31.2-69.8-69.8-69.8H93.1V69.8z"
      />
      <path d="M325.8,23.3v93.1c0,12.9,10.4,23.3,23.3,23.3s23.3-10.4,23.3-23.3V23.3c0-12.9-10.4-23.3-23.3-23.3S325.8,10.4,325.8,23.3" />
      <path
        d="M139.6,23.3v93.1c0,12.9,10.4,23.3,23.3,23.3c12.9,0,23.3-10.4,23.3-23.3V23.3c0-12.9-10.4-23.3-23.3-23.3
		C150.1,0,139.6,10.4,139.6,23.3"
      />
      <path
        d="M46.5,232.7h418.9c12.9,0,23.3-10.4,23.3-23.3c0-12.9-10.4-23.3-23.3-23.3H46.5c-12.9,0-23.3,10.4-23.3,23.3
		C23.3,222.3,33.7,232.7,46.5,232.7"
      />
    </g>
  </svg>
);

export const filterIcon = (
  <svg
    width={21}
    height={13}
    viewBox="0 0 21 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.076 1.5H.354M16.532 6.5H3.897M13.09 11.5H7.35"
      stroke="#1B1C21"
      strokeWidth={2}
    />
  </svg>
);

export const dotsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-three-dots"
    viewBox="0 0 16 16"
  >
    <path d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
  </svg>
);

export const certifiedIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={11.4}
      height={17.861}
      viewBox="0 0 11.4 17.861" 
    >
      <g
        transform="translate(-901.3 -101.3) translate(896.616 100.539)"
        fill="#f8c068"
        stroke="#d89e42"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        data-name="Group 27703"
      >
        <path
          data-name="Path 49034"
          d="M7.469 10.915l-.931 7.007 3.846-2.307 3.846 2.307-.931-7.015"
        />
        <circle
          data-name="Ellipse 438"
          cx={5}
          cy={5}
          r={5}
          transform="translate(5.384 1.461)"
        />
      </g>
    </svg>
);

export const fullAccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.195}
    height={8.646}
    viewBox="0 0 17.195 8.646"
  >
    <path
      data-name="Path 40521"
      d="M113.593 160.776a5.767 5.767 0 00-1.794-1.651 4 4 0 00-1.239-.448 4.4 4.4 0 00-1.439-.009 4.161 4.161 0 00-1.984 7.29 4.129 4.129 0 00.978.613 4.477 4.477 0 001.286.344 4.059 4.059 0 002.54-.577 5.989 5.989 0 001.76-1.719 7.735 7.735 0 00.9-1.7c.021-.055.041-.107.064-.16l-.056.135a7.5 7.5 0 01.842-1.489l.073-.1.023-.028a.463.463 0 00-.043.056l.124-.154c.085-.1.171-.2.263-.3a4.857 4.857 0 01.44-.414c.024-.021.049-.039.073-.058s.07-.055 0 0-.008.006.008-.006a4.035 4.035 0 01.827-.479l-.135.056a3.529 3.529 0 01.888-.243l-.15.021a3.61 3.61 0 01.955 0l-.15-.021a3.635 3.635 0 01.9.246l-.135-.056a3.594 3.594 0 01.609.329c.047.032.094.066.141.1s.105.09-.036-.028c.024.021.051.041.077.062.085.071.167.145.244.224s.152.16.224.244c.013.015.06.056.062.077 0-.024-.094-.124-.028-.036.034.047.068.094.1.141a3.594 3.594 0 01.329.609l-.056-.135a3.656 3.656 0 01.246.9l-.021-.15a3.8 3.8 0 010 .991l.021-.15a3.634 3.634 0 01-.246.9l.056-.135a3.594 3.594 0 01-.329.609c-.032.047-.066.094-.1.141s-.09.105.028-.036c-.021.024-.041.051-.062.077-.071.085-.145.167-.224.244s-.16.152-.244.224c-.015.013-.056.06-.077.062.024 0 .124-.094.036-.028a6.106 6.106 0 01-.141.1 3.593 3.593 0 01-.609.329l.135-.056a3.657 3.657 0 01-.9.246l.15-.021a3.61 3.61 0 01-.955 0l.15.021a3.55 3.55 0 01-.888-.243l.135.056a3.76 3.76 0 01-.583-.31c-.087-.056-.173-.115-.256-.179s.075.06.028.023l-.062-.051-.122-.1a5.574 5.574 0 01-.438-.431c-.068-.075-.134-.152-.2-.229l-.085-.107c-.07-.088.064.085.028.036l-.051-.068a.61.61 0 00-.337-.26.564.564 0 00-.694.393.547.547 0 00.056.434 5.767 5.767 0 001.794 1.651 4 4 0 001.239.448 4.4 4.4 0 001.438.009 4.161 4.161 0 001.986-7.29 4.13 4.13 0 00-.978-.613 4.477 4.477 0 00-1.286-.344 4.059 4.059 0 00-2.54.577 5.989 5.989 0 00-1.76 1.719 7.735 7.735 0 00-.9 1.7 3.808 3.808 0 01-.064.16l.056-.135a7.565 7.565 0 01-.842 1.491l-.073.1-.023.028a.463.463 0 00.043-.056l-.124.154c-.085.1-.171.2-.263.3a4.857 4.857 0 01-.44.414c-.024.021-.049.039-.073.058s-.07.055 0 0 .008-.006-.008.006a4.036 4.036 0 01-.827.479l.135-.056a3.529 3.529 0 01-.888.243l.15-.021a3.61 3.61 0 01-.955 0l.15.021a3.634 3.634 0 01-.9-.246l.135.056a3.593 3.593 0 01-.609-.329c-.047-.032-.094-.066-.141-.1s-.105-.09.036.028c-.024-.021-.051-.041-.077-.062-.085-.071-.167-.145-.244-.224s-.152-.16-.224-.244c-.013-.015-.06-.056-.062-.077 0 .024.094.124.028.036-.034-.047-.068-.094-.1-.141a3.594 3.594 0 01-.329-.609l.056.135a3.656 3.656 0 01-.246-.9l.021.15a3.8 3.8 0 010-.991l-.021.15a3.634 3.634 0 01.246-.9l-.056.135a3.594 3.594 0 01.329-.609c.032-.047.066-.094.1-.141s.09-.105-.028.036c.021-.024.041-.051.062-.077.071-.085.145-.167.224-.244s.16-.152.244-.224c.015-.013.056-.06.077-.062-.024 0-.124.094-.036.028.047-.034.094-.068.141-.1a3.592 3.592 0 01.609-.329l-.135.056a3.657 3.657 0 01.9-.246l-.15.021a3.611 3.611 0 01.955 0l-.15-.021a3.55 3.55 0 01.888.243l-.135-.056a3.919 3.919 0 01.583.308c.086.056.173.115.256.179s-.075-.06-.028-.023l.062.051.122.1a5.569 5.569 0 01.438.431c.068.075.134.152.2.229l.085.107c.07.088-.064-.085-.028-.036l.051.068a.61.61 0 00.337.259.564.564 0 00.694-.393.557.557 0 00-.058-.434z"
      fill="#ced2d9"
      stroke="#ced2d9"
      strokeWidth={0.3}
      transform="translate(-105.462 -158.446)"
    />
  </svg>
);

export const daysIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={15.622}
    viewBox="0 0 14.2 15.622"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#ced2d9"
      strokeWidth={1.4}
    >
      <rect
        data-name="Rectangle 10"
        width={12.8}
        height={12.8}
        rx={2}
        transform="translate(0 1.422)"
      />
      <path
        data-name="Line 2"
        transform="translate(9.244)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 3"
        transform="translate(3.556)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 4"
        transform="translate(0 5.689)"
        strokeLinejoin="round"
        d="M0 0L12.8 0"
      />
    </g>
  </svg>
);

export const dateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={15.622}
    viewBox="0 0 14.2 15.622"
  >
    <g data-name="Group 18386" stroke="#ced2d9" strokeLinecap="round">
      <g fill="none" strokeWidth={1.4} transform="translate(.7 .7)">
        <rect
          data-name="Rectangle 10"
          width={12.8}
          height={12.8}
          rx={2}
          transform="translate(0 1.422)"
        />
        <path
          data-name="Line 2"
          transform="translate(9.244)"
          strokeLinejoin="round"
          d="M0 0L0 2.844"
        />
        <path
          data-name="Line 3"
          transform="translate(3.556)"
          strokeLinejoin="round"
          d="M0 0L0 2.844"
        />
        <path
          data-name="Line 4"
          transform="translate(0 5.689)"
          strokeLinejoin="round"
          d="M0 0L12.8 0"
        />
      </g>
      <g
        data-name="Ellipse 1"
        transform="translate(.7 .7) translate(7.944 9.244)"
        fill="#ced2d9"
        strokeWidth={1}
      >
        <circle cx={1.422} cy={1.422} r={1.422} stroke="none" />
        <circle cx={1.422} cy={1.422} r={0.922} fill="none" />
      </g>
    </g>
  </svg>
);

export const questionPool = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.159"
    height="15.929"
    viewBox="0 0 16.159 15.929"
  >
    <g
      id="Question_Pool"
      data-name="Question Pool"
      transform="translate(0.89 0.852)"
    >
      <path
        id="Path_21716"
        data-name="Path 21716"
        d="M16.279,8.481v.657a7.14,7.14,0,1,1-4.234-6.526"
        transform="translate(-2 -1.994)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21717"
        data-name="Path 21717"
        d="M18.282,4l-7.14,7.147L9,9"
        transform="translate(-4.002 -2.568)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const tagCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.764}
    height={7.764}
    pointerEvents="none"
    viewBox="0 0 7.764 7.764"
  >
    <g
      data-name="Group 18380"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21632"
        d="M5.784 0L0 5.784"
        transform="translate(.99 .99)"
      />
      <path
        data-name="Path 21633"
        d="M5.784 5.784L0 0"
        transform="translate(.99 .99)"
      />
    </g>
  </svg>
);

export const exclamationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-exclamation-circle"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
  </svg>
);

export const oliveLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76.675}
    height={19.286}
    viewBox="0 0 76.675 19.286"
  >
    <g transform="translate(.014 .016)">
      <path
        data-name="Path 36"
        d="M269.552 196.37l-.012 3.729 11.521.036.012-3.728-7.483-.024z"
        transform="translate(-247.596 -181.274)"
      />
      <path
        data-name="Rectangle 3071"
        transform="rotate(-89.828 43.72 -24.825)"
        d="M0 0H3.728V8.189H0z"
      />
      <path
        data-name="Rectangle 3072"
        transform="rotate(-89.828 22.965 -13.3)"
        d="M0 0H9.166V4.039H0z"
      />
      <path
        data-name="Rectangle 3073"
        transform="rotate(-89.828 27.546 -8.703)"
        d="M0 0H9.166V4.039H0z"
      />
      <path
        data-name="Rectangle 3074"
        transform="rotate(-90 18.484 -3.414)"
        d="M0 0H14.603V4.039H0z"
      />
      <path
        data-name="Path 37"
        d="M513.661 30.713l-4.291-.013 7.162 18.353 4.292.013z"
        transform="translate(-466.385 -30.139)"
      />
      <path
        data-name="Rectangle 3075"
        transform="rotate(-90 39.851 -28.361)"
        d="M0 0H3.728V7.735H0z"
      />
      <path
        data-name="Rectangle 3076"
        transform="rotate(-89.828 36.422 -32.15)"
        d="M0 0H3.728V8.189H0z"
      />
      <path
        data-name="Path 38"
        d="M753.643 31.47l-.023 7.145 4.038.013.011-3.418.012-3.728z"
        transform="translate(-689.205 -30.842)"
      />
      <path
        data-name="Path 39"
        d="M753.21 124.1l4.039.013.011-3.728.012-3.729.011-3.728-4.04-.013z"
        transform="translate(-688.831 -105.146)"
      />
      <path
        data-name="Path 40"
        d="M628.63 46.885l6.326-15.912-4.291-.013-4.165 10.472z"
        transform="translate(-573.238 -30.377)"
      />
      <path
        data-name="Path 41"
        d="M24.236 37.159A5.778 5.778 0 0132.3 29.1l2.743-2.743A9.629 9.629 0 0021.491 39.9z"
        transform="translate(-19.329 -24.194)"
      />
      <path
        data-name="Path 42"
        d="M70.674 67.749a5.778 5.778 0 01-8.045 8.043l-2.751 2.751A9.629 9.629 0 0073.425 65z"
        transform="translate(-56.329 -61.43)"
      />
    </g>
  </svg>
);

export const imgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={15.19} height={15.19}>
    <g
      data-name="Icon feather-image"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40523"
        d="M2.2.7h10.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5H2.2a1.5 1.5 0 0 1-1.5-1.5V2.2A1.5 1.5 0 0 1 2.2.7Z"
      />
      <path
        data-name="Path 40524"
        d="M5.95 4.825A1.125 1.125 0 1 1 4.825 3.7 1.125 1.125 0 0 1 5.95 4.825Z"
      />
      <path data-name="Path 40525" d="m14.2 9.7-3.75-3.75L2.2 14.2" />
    </g>
  </svg>
);

export const userIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 100-6 3 3 0 000 6zm2-3a2 2 0 11-4 0 2 2 0 014 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
  </svg>
);

export const phoneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.718}
    height={12.741}
    viewBox="0 0 12.718 12.741"
  >
    <path
      d="M12.017 9.19v1.71a1.138 1.138 0 01-1.241 1.138 11.261 11.261 0 01-4.911-1.747 11.1 11.1 0 01-3.414-3.417A11.261 11.261 0 01.704 1.94 1.138 1.138 0 011.837.7h1.707a1.138 1.138 0 011.138.979 7.307 7.307 0 00.4 1.6 1.138 1.138 0 01-.256 1.2l-.724.721a9.1 9.1 0 003.414 3.415l.723-.723a1.138 1.138 0 011.2-.256 7.307 7.307 0 001.6.4 1.138 1.138 0 01.979 1.155z"
      fill="rgba(0,0,0,0)"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const envelopeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.009}
    height={13.447}
    viewBox="0 0 17.009 13.447"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 49003"
        d="M3.506 4h12.047a1.51 1.51 0 011.506 1.506v9.035a1.51 1.51 0 01-1.506 1.506H3.506A1.51 1.51 0 012 14.541V5.506A1.51 1.51 0 013.506 4z"
        transform="translate(-1.025 -3.3)"
      />
      <path
        data-name="Path 49004"
        d="M17.059 5.506L9.53 10.777 2 5.506"
        transform="translate(-1.025 -3.3)"
      />
    </g>
  </svg>
);

export const headerPhoneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16} height={16}
    stroke="currentColor"
    viewBox="0 0 16 16">
    <path d="M15.389,11.96v2A1.335,1.335,0,0,1,13.933,15.3a13.211,13.211,0,0,1-5.761-2.049A13.018,13.018,0,0,1,4.167,9.243,13.211,13.211,0,0,1,2.117,3.455,1.335,1.335,0,0,1,3.446,2h2A1.335,1.335,0,0,1,6.784,3.148a8.572,8.572,0,0,0,.467,1.876,1.335,1.335,0,0,1-.3,1.409L6.1,7.28a10.681,10.681,0,0,0,4.005,4.005l.848-.848a1.335,1.335,0,0,1,1.409-.3,8.572,8.572,0,0,0,1.876.467A1.335,1.335,0,0,1,15.389,11.96Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" />
  </svg>
);

export const searchIcon = (
  <svg
    data-name="Group 17"
    xmlns="http://www.w3.org/2000/svg"
    width={13.605}
    height={13.605}
    viewBox="0 0 13.605 13.605"
  >
    <path
      data-name="Path 7"
      d="M11.643 11.643l.971.971"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.4}
    />
    <g data-name="Ellipse 2" fill="none" stroke="currentColor" strokeWidth={1.4}>
      <circle cx={6.189} cy={6.189} r={6.189} stroke="none" />
      <circle cx={6.189} cy={6.189} r={5.489} fill="none" />
    </g>
  </svg>
);
export const eyeClosedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.149} height={16.98}>
    <g fill="none" stroke="#9b9ba2">
      <path
        data-name="Path 21633"
        d="M12.752 12.763a7.164 7.164 0 0 1-4.226 1.466C3.546 14.228.7 8.537.7 8.537a13.126 13.126 0 0 1 3.6-4.226m2.732-1.295a6.489 6.489 0 0 1 1.494-.171c4.98 0 7.826 5.692 7.826 5.692a13.162 13.162 0 0 1-1.537 2.27m-4.781-.762a2.134 2.134 0 1 1-3.016-3.017"
      />
      <path data-name="Line 160" d="m1.159.99 15 15" />
    </g>
  </svg>
);

export const layersStackIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={16.016} height={15.538}>
    <g
      data-name="Icon feather-layers"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40526"
        d="M8.008.7.939 4.234l7.069 3.534 7.069-3.534Z"
      />
      <path data-name="Path 40527" d="m.939 11.303 7.069 3.534 7.069-3.534" />
      <path data-name="Path 40528" d="m.939 7.769 7.069 3.534 7.069-3.534" />
    </g>
  </svg>
);

export const keyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.524}
    height={15.107}
    viewBox="0 0 15.524 15.107"
  >
    <path
      d="M14.117.99l-1.412 1.412M7.33 7.777a3.884 3.884 0 11-5.493 0 3.884 3.884 0 015.493 0zm0 0l2.9-2.9m0 0l2.121 2.113 2.472-2.472-2.118-2.116m-2.472 2.472l2.472-2.472"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);
export const eyeOpenedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.093} height={12.813}>
    <g transform="translate(-.3 -3.3)" fill="none" stroke="#6f75bc">
      <path
        data-name="Path 21634"
        d="M1 9.707S3.853 4 8.847 4s7.847 5.707 7.847 5.707-2.853 5.707-7.847 5.707S1 9.707 1 9.707Z"
      />
      <circle
        data-name="Ellipse 35"
        cx={2}
        cy={2}
        r={2}
        transform="translate(7 7.413)"
      />
    </g>
  </svg>
);

export const divisionIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={14.252} height={14.252}>
    <path
      d="M7.126.7h5a1.428 1.428 0 0 1 1.428 1.428v10a1.428 1.428 0 0 1-1.428 1.428h-5M7.126.7h-5A1.428 1.428 0 0 0 .7 2.128v10a1.428 1.428 0 0 0 1.428 1.428h5M7.126.7v12.852"
      fill="rgba(0,0,0,0)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

// export const clockIcon = (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={16}
//     height={16}
//     fill="currentColor"
//     className="bi bi-clock"
//   >
//     <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
//     <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
//   </svg>
// );

export const clockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.4}
    height={12.4}
    viewBox="0 0 12.4 12.4"
  >
    <g
      transform="translate(-1.128 -1.128)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 435"
        cx={5.5}
        cy={5.5}
        r={5.5}
        transform="translate(1.828 1.828)"
      />
      <path data-name="Path 49019" d="M7.405 4.167v3.238l2.159 1.079" />
    </g>
  </svg>
)

export const checkCircleFill = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-check-circle-fill"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05z" />
  </svg>
);

export const thumbsUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 235.5 250"
    xmlSpace="preserve"
  >
    <path
      d="M194.9 78.7c-23.9-.2-60.7.1-60.7.1s1-4.2 3.5-38.1c2.5-34.2-39.1-38.9-43.5-38-4.5.9-5.2 3-6.5 6.3-1.3 3.3-27.4 69.4-27.4 69.4s-30.2-.2-37 .6c-9.2.7-19.1 9.7-19.1 20.8V227c2 11.1 10.9 16.6 17.8 19.1 7.5.2 22.5.5 29.5.4 8.2-.2 15.4-7.7 18.5-12 6.8 4.3 27.5 11.9 37.2 11.8 11.5-.1 31.2.4 64 0 29.8-.4 36.6-20.7 38.6-28 3.9-13.7 10-45.6 19.7-80.6 13.1-47.4-19.9-58.8-34.6-59zM57.2 224.5c0 2.3-3 6.1-5.7 6.7-3.2 0-23.2.2-25.3 0-1.9-.4-6.9-1.3-6.7-10.4.1-7 .2-113.5 0-118.4-.2-5 3.5-8.4 6.2-8.4h31.5v130.5zm158.3-94.4c-5.9 23.3-17.9 75.6-21.3 87.2-2.5 8.3-14 13.9-20.6 13.7-13.7-.4-60.4.7-67.6 0-15.6-1.5-26.9-8.9-33.2-12.2.1-4.4 0-131 0-131l28.1-69.9s23.6 3 22.1 24.3c-1.1 15.7-4.4 34.9-4.6 44.4-.1 4.5 3.8 7.4 6.4 7.4 2.7 0 50.6-.3 70.9.3 13.7.5 26.1 11.1 19.8 35.8z"
      fill="currentColor"
    />
  </svg>
);

export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    xmlSpace="preserve"
  >
    <circle cx={25} cy={25} r={25} fill="#fff" />
    <path fill="#13171f" d="M31.5 25L18.5 17.5 18.5 32.5z" style={{ transform: "translateX(2px)" }} />
  </svg>
);

// export const StarIcon = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={16}
//     height={16}
//     fill="currentColor"
//     className="bi bi-star-fill"
//     viewBox="0 0 16 16"
//     {...props}
//   >
//     <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
//   </svg>
// );

export const StarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.694}
    height={13.974}
    viewBox="0 0 14.694 13.974"
    {...props}
  >
    <path
      data-name="star (1)"
      d="M9.347 2l2.27 4.6 5.077.742-3.674 3.577.867 5.055-4.54-2.388-4.54 2.388.867-5.055L2 7.341 7.077 6.6z"
      transform="translate(-2 -2)"
      fill="currentColor"
    />
  </svg>
);

export const iconStar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.694}
    height={13.974}
    viewBox="0 0 14.694 13.974"
  >
    <path
      data-name="star"
      d="M9.347 2l2.27 4.6 5.077.742-3.674 3.577.867 5.055-4.54-2.388-4.54 2.388.867-5.055L2 7.341 7.077 6.6z"
      transform="translate(-2 -2)"
      fill="#f8c068"
    />
  </svg>
);

export const bookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-book"
    viewBox="0 0 16 16"
  >
    <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 000 2.5v11a.5.5 0 00.707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 00.78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0016 13.5v-11a.5.5 0 00-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
  </svg>
);

export const checkCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.072}
    height={12.831}
    viewBox="0 0 13.072 12.831"
  >
    <g
      fill="none"
      stroke="#a4a7ad"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21716"
        d="M11.229 5.106v.517A5.615 5.615 0 117.9.486"
        transform="translate(.853 .822)"
      />
      <path
        data-name="Path 21717"
        d="M11.23 1.126l-5.616 5.62L3.93 5.062"
        transform="translate(.853 .822)"
      />
    </g>
  </svg>
);

// export const checkCircleFill = (
//   <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={16}
//       height={16}
//       fill="currentColor"
//       className="bi bi-check-circle-fill"
//       viewBox="0 0 16 16"
//       {...props}
//     >
//       <path d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05z" />
//     </svg>
// )

export const pointMapIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-geo-alt"
    viewBox="0 0 16 16"
  >
    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 018 14.58a31.481 31.481 0 01-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0110 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 002 6c0 4.314 6 10 6 10z" />
    <path d="M8 8a2 2 0 110-4 2 2 0 010 4zm0 1a3 3 0 100-6 3 3 0 000 6z" />
  </svg>
);

export const geoMarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.607}
    height={12.654}
    viewBox="0 0 10.607 12.654"
  >
    <g
      data-name="map-pin (1)"
      transform="translate(-2.3 -.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 49018"
        d="M12.207 5.6c0 3.581-4.6 6.65-4.6 6.65S3 9.184 3 5.6a4.604 4.604 0 119.207 0z"
      />
      <circle
        data-name="Ellipse 434"
        cx={1.876}
        cy={1.876}
        r={1.876}
        transform="translate(5.728 3.813)"
      />
    </g>
  </svg>
);

export const folderBlueIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={21.916} height={18.189} viewBox="0 0 21.916 18.189">
    <g data-name="Group 20972" transform="translate(14021.958 -7748.905)">
      <path
        data-name="Path 49286"
        d="M2281.169 518.651v-3.916a2.228 2.228 0 011.972-2.416h4.237a1.742 1.742 0 011.161.464l1.845 1.647h10.729a2.228 2.228 0 011.972 2.416v1.805z"
        transform="translate(-16303.127 7236.586)"
        fill="#397ff5"
      />
      <rect data-name="Rectangle 11501" width={21.915} height={14.144} rx={2} transform="translate(-14021.957 7752.949)" fill="#73a4f8" />
    </g>
  </svg>
);

export const insertPdfIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve">
    <path d="M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z" fill="#e2e5e7" />
    <path d="M384 128h96L352 0v96c0 17.6 14.4 32 32 32z" fill="#b0b7bd" />
    <path fill="#cad1d8" d="M480 224L384 128 480 128z" />
    <path d="M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z" fill="#f15642" />
    <g fill="#fff">
      <path d="M101.744 303.152c0-4.224 3.328-8.832 8.688-8.832h29.552c16.64 0 31.616 11.136 31.616 32.48 0 20.224-14.976 31.488-31.616 31.488h-21.36v16.896c0 5.632-3.584 8.816-8.192 8.816-4.224 0-8.688-3.184-8.688-8.816v-72.032zm16.88 7.28v31.872h21.36c8.576 0 15.36-7.568 15.36-15.504 0-8.944-6.784-16.368-15.36-16.368h-21.36zM196.656 384c-4.224 0-8.832-2.304-8.832-7.92v-72.672c0-4.592 4.608-7.936 8.832-7.936h29.296c58.464 0 57.184 88.528 1.152 88.528h-30.448zm8.064-72.912V368.4h21.232c34.544 0 36.08-57.312 0-57.312H204.72zM303.872 312.112v20.336h32.624c4.608 0 9.216 4.608 9.216 9.072 0 4.224-4.608 7.68-9.216 7.68h-32.624v26.864c0 4.48-3.184 7.92-7.664 7.92-5.632 0-9.072-3.44-9.072-7.92v-72.672c0-4.592 3.456-7.936 9.072-7.936h44.912c5.632 0 8.96 3.344 8.96 7.936 0 4.096-3.328 8.704-8.96 8.704h-37.248v.016z" />
    </g>
    <path d="M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z" fill="#cad1d8" />
  </svg>
);

export const insertPngIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve">
    <path d="M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z" fill="#e2e5e7" />
    <path d="M384 128h96L352 0v96c0 17.6 14.4 32 32 32z" fill="#b0b7bd" />
    <path fill="#cad1d8" d="M480 224L384 128 480 128z" />
    <path d="M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z" fill="#a066aa" />
    <g fill="#fff">
      <path d="M92.816 303.152c0-4.224 3.312-8.848 8.688-8.848h29.568c16.624 0 31.6 11.136 31.6 32.496 0 20.224-14.976 31.472-31.6 31.472H109.68v16.896c0 5.648-3.552 8.832-8.176 8.832-4.224 0-8.688-3.184-8.688-8.832v-72.016zm16.864 7.28v31.856h21.376c8.56 0 15.344-7.552 15.344-15.488 0-8.96-6.784-16.368-15.344-16.368H109.68zM178.976 304.432c0-4.624 1.024-9.088 7.68-9.088 4.592 0 5.632 1.152 9.072 4.464l42.336 52.976v-49.632c0-4.224 3.696-8.848 8.064-8.848 4.608 0 9.072 4.624 9.072 8.848v72.016c0 5.648-3.456 7.792-6.784 8.832-4.464 0-6.656-1.024-10.352-4.464l-42.336-53.744v49.392c0 5.648-3.456 8.832-8.064 8.832s-8.704-3.184-8.704-8.832v-70.752h.016zM351.44 374.16c-9.088 7.536-20.224 10.752-31.472 10.752-26.88 0-45.936-15.36-45.936-45.808 0-25.84 20.096-45.92 47.072-45.92 10.112 0 21.232 3.456 29.168 11.264 7.808 7.664-3.456 19.056-11.12 12.288-4.736-4.624-11.392-8.064-18.048-8.064-15.472 0-30.432 12.4-30.432 30.432 0 18.944 12.528 30.448 29.296 30.448 7.792 0 14.448-2.304 19.184-5.76V348.08h-19.184c-11.392 0-10.24-15.632 0-15.632h25.584c4.736 0 9.072 3.6 9.072 7.568v27.248c0 2.288-1.008 4.448-3.184 6.896z" />
    </g>
    <path d="M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z" fill="#cad1d8" />
  </svg>
);

export const shareOIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-share"
    viewBox="0 0 16 16"
  >
    <path d="M13.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11 2.5a2.5 2.5 0 11.603 1.628l-6.718 3.12a2.499 2.499 0 010 1.504l6.718 3.12a2.5 2.5 0 11-.488.876l-6.718-3.12a2.5 2.5 0 110-3.256l6.718-3.12A2.5 2.5 0 0111 2.5zm-8.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11 5.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
  </svg>
)

export const customiseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-sliders2"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M10.5 1a.5.5 0 01.5.5v4a.5.5 0 01-1 0V4H1.5a.5.5 0 010-1H10V1.5a.5.5 0 01.5-.5zM12 3.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm-6.5 2A.5.5 0 016 6v1.5h8.5a.5.5 0 010 1H6V10a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zM1 8a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2A.5.5 0 011 8zm9.5 2a.5.5 0 01.5.5v4a.5.5 0 01-1 0V13H1.5a.5.5 0 010-1H10v-1.5a.5.5 0 01.5-.5zm1.5 2.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5z"
    />
  </svg>
)

export const stackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-stack"
    viewBox="0 0 16 16"
  >
    <path d="M14.12 10.163l1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 01-.534 0L.165 11.555a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 01.534 0l7.568 3.784a.3.3 0 010 .535L8.267 8.165a.598.598 0 01-.534 0L.165 4.382a.299.299 0 010-.535L7.733.063z" />
    <path d="M14.12 6.576l1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 01-.534 0L.165 7.968a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z" />
  </svg>
)

export const boxOIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box2"
    viewBox="0 0 16 16"
  >
    <path d="M2.95.4a1 1 0 01.8-.4h8.5a1 1 0 01.8.4l2.85 3.8a.5.5 0 01.1.3V15a1 1 0 01-1 1H1a1 1 0 01-1-1V4.5a.5.5 0 01.1-.3L2.95.4zM7.5 1H3.75L1.5 4h6V1zm1 0v3h6l-2.25-3H8.5zM15 5H1v10h14V5z" />
  </svg>
)

export const awardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-award-fill"
    viewBox="0 0 16 16"
  >
    <path d="M8 0l1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z" />
    <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z" />
  </svg>
)


export const chervonRightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-chevron-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"
    />
  </svg>
);

export const twitterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-twitter"
    viewBox="0 0 16 16"
  >
    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0016 3.542a6.658 6.658 0 01-1.889.518 3.301 3.301 0 001.447-1.817 6.533 6.533 0 01-2.087.793A3.286 3.286 0 007.875 6.03a9.325 9.325 0 01-6.767-3.429 3.289 3.289 0 001.018 4.382A3.323 3.323 0 01.64 6.575v.045a3.288 3.288 0 002.632 3.218 3.203 3.203 0 01-.865.115 3.23 3.23 0 01-.614-.057 3.283 3.283 0 003.067 2.277A6.588 6.588 0 01.78 13.58a6.32 6.32 0 01-.78-.045A9.344 9.344 0 005.026 15z" />
  </svg>
);

export const instaLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-instagram"
    viewBox="0 0 16 16"
  >
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 00-1.417.923A3.927 3.927 0 00.42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 001.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 00-.923-1.417A3.911 3.911 0 0013.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 01-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 01-.92-.598 2.48 2.48 0 01-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 100 1.92.96.96 0 000-1.92zm-4.27 1.122a4.109 4.109 0 100 8.217 4.109 4.109 0 000-8.217zm0 1.441a2.667 2.667 0 110 5.334 2.667 2.667 0 010-5.334z" />
  </svg>
);

export const facebookLogoIcon = (
  <svg
    width={16}
    height={16}
    viewBox="-5 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M335.821 7259v-9h2.733l.446-4h-3.179v-1.948c0-1.03.027-2.052 1.466-2.052h1.458v-2.86c0-.043-1.253-.14-2.52-.14-2.645 0-4.302 1.657-4.302 4.7v2.3H329v4h2.923v9h3.898z"
      transform="translate(-385 -7399) translate(56 160)"
      fill="currentColor"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    />
  </svg>
);

export const whatsAppLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 2 22 21"
    width={16}
    height={16}
    fill="currentColor"
  >
    <path d="M19.077,4.928c-2.082-2.083-4.922-3.134-7.904-2.894C7.164,2.356,3.65,5.144,2.474,8.99 c-0.84,2.748-0.487,5.617,0.881,7.987L2.059,21.28c-0.124,0.413,0.253,0.802,0.67,0.691l4.504-1.207 c1.459,0.796,3.101,1.215,4.773,1.216h0.004c4.195,0,8.071-2.566,9.412-6.541C22.728,11.563,21.762,7.616,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767 c-0.125-0.167-1.019-1.353-1.019-2.581S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006 c0.178,0.007,0.375,0.016,0.562,0.431c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416 c-0.125,0.146-0.262,0.325-0.374,0.437c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728 c0.954,0.85,1.757,1.113,2.007,1.239c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978 s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812c0.25,0.125,0.416,0.187,0.478,0.291 C17.106,14.471,17.106,14.971,16.898,15.554z" />
  </svg>
);

export const telegramLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    width={16}
    height={16}
    fill="currentColor"
  >
    <path d="M46.137,6.552c-0.75-0.636-1.928-0.727-3.146-0.238l-0.002,0C41.708,6.828,6.728,21.832,5.304,22.445	c-0.259,0.09-2.521,0.934-2.288,2.814c0.208,1.695,2.026,2.397,2.248,2.478l8.893,3.045c0.59,1.964,2.765,9.21,3.246,10.758	c0.3,0.965,0.789,2.233,1.646,2.494c0.752,0.29,1.5,0.025,1.984-0.355l5.437-5.043l8.777,6.845l0.209,0.125	c0.596,0.264,1.167,0.396,1.712,0.396c0.421,0,0.825-0.079,1.211-0.237c1.315-0.54,1.841-1.793,1.896-1.935l6.556-34.077	C47.231,7.933,46.675,7.007,46.137,6.552z M22,32l-3,8l-3-10l23-17L22,32z" />
  </svg>
);

export const youTubeLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="7 5 50 50"
  >
    <path d="M56.456,17.442c-0.339-1.44-1.421-2.595-2.866-3.053C49.761,13.174,41.454,12,32,12s-17.761,1.174-21.591,2.389 c-1.445,0.458-2.527,1.613-2.866,3.053C6.903,20.161,6,25.203,6,32c0,6.797,0.903,11.839,1.544,14.558 c0.339,1.44,1.421,2.595,2.866,3.053C14.239,50.826,22.546,52,32,52s17.761-1.174,21.591-2.389 c1.445-0.458,2.527-1.613,2.866-3.053C57.097,43.839,58,38.797,58,32C58,25.203,57.097,20.161,56.456,17.442z M27,40V24l14.857,8 L27,40z" />
  </svg>
);

export const linkedInLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 50 50"
  >
    <path d="M 8 3.0097656 C 4.53 3.0097656 2.0097656 5.0892187 2.0097656 7.9492188 C 2.0097656 10.819219 4.59 12.990234 8 12.990234 C 11.47 12.990234 13.990234 10.870625 13.990234 7.890625 C 13.830234 5.020625 11.36 3.0097656 8 3.0097656 z M 3 15 C 2.45 15 2 15.45 2 16 L 2 45 C 2 45.55 2.45 46 3 46 L 13 46 C 13.55 46 14 45.55 14 45 L 14 16 C 14 15.45 13.55 15 13 15 L 3 15 z M 18 15 C 17.45 15 17 15.45 17 16 L 17 45 C 17 45.55 17.45 46 18 46 L 27 46 C 27.552 46 28 45.552 28 45 L 28 30 L 28 29.75 L 28 29.5 C 28 27.13 29.820625 25.199531 32.140625 25.019531 C 32.260625 24.999531 32.38 25 32.5 25 C 32.62 25 32.739375 24.999531 32.859375 25.019531 C 35.179375 25.199531 37 27.13 37 29.5 L 37 45 C 37 45.552 37.448 46 38 46 L 47 46 C 47.55 46 48 45.55 48 45 L 48 28 C 48 21.53 44.529063 15 36.789062 15 C 33.269062 15 30.61 16.360234 29 17.490234 L 29 16 C 29 15.45 28.55 15 28 15 L 18 15 z" />
  </svg>
);

export const cashIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-cash"
    viewBox="0 0 16 16"
  >
    <path d="M8 10a2 2 0 100-4 2 2 0 000 4z" />
    <path d="M0 4a1 1 0 011-1h14a1 1 0 011 1v8a1 1 0 01-1 1H1a1 1 0 01-1-1V4zm3 0a2 2 0 01-2 2v4a2 2 0 012 2h10a2 2 0 012-2V6a2 2 0 01-2-2H3z" />
  </svg>
)

export const cartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.099}
    height={17.4}
    viewBox="0 0 17.099 17.4"
  >
    <g
      transform="translate(-.3 -.3)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 407"
        cx={1}
        cy={1}
        r={1}
        transform="translate(5.849 15)"
        fill="currentColor"
      />
      <circle
        data-name="Ellipse 408"
        cx={1}
        cy={1}
        r={1}
        transform="translate(13.849 15)"
        fill="currentColor"
      />
      <path
        data-name="Path 49005"
        d="M1 1h2.854l1.912 9.555A1.427 1.427 0 007.194 11.7h6.936a1.427 1.427 0 001.427-1.149L16.7 4.568H4.568"
        fill="none"
      />
    </g>
  </svg>
)

export const infinityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.088}
    height={9.098}
    viewBox="0 0 16.088 9.098"
  >
    <path
      data-name="Path 49045"
      d="M4.527 7.285A2.765 2.765 0 101.763 4.52a2.765 2.765 0 002.764 2.765zM8.872 4.52a2.765 2.765 0 10.527-1.624 5.121 5.121 0 00-.791-1.491 4.344 4.344 0 11-.525 5.614 4.344 4.344 0 11.79-2.5z"
      fill="currentColor"
      stroke="#fff"
      strokeWidth={0.2}
    />
  </svg>
)

export const globeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-globe2"
    viewBox="0 0 16 16"
  >
    <path d="M0 8a8 8 0 1116 0A8 8 0 010 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 01.597-.933A7.01 7.01 0 003.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 01-1.565-.667A6.964 6.964 0 001.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 00-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 00-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 017.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 01-.598-.933 8.853 8.853 0 01-.481-1.079 8.38 8.38 0 00-1.198.49 7.01 7.01 0 002.276 1.522zm-1.383-2.964A13.36 13.36 0 013.508 8.5h-2.49a6.963 6.963 0 001.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 002.275-1.521 8.376 8.376 0 00-1.197-.49 8.853 8.853 0 01-.481 1.078 6.688 6.688 0 01-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 008.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0014.982 8.5h-2.49a13.36 13.36 0 01-.437 3.008zM14.982 7.5a6.963 6.963 0 00-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 001.196-.49 7.01 7.01 0 00-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 00-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
  </svg>
)

export const globeBoldIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width={16.4}
    height={16.4}
    viewBox="0 0 16.4 16.4"
  >
    <g
      transform="translate(-1.188 -1.188)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 266"
        cx={7.5}
        cy={7.5}
        r={7.5}
        transform="translate(1.888 1.888)"
      />
      <path
        data-name="Line 836"
        transform="translate(1.888 9.888)"
        d="M0 0L15 0"
      />
      <path
        data-name="Path 40570"
        d="M9.388 1.993a11.314 11.314 0 012.958 7.395 11.314 11.314 0 01-2.958 7.4A11.314 11.314 0 016.43 9.393a11.314 11.314 0 012.958-7.4z"
      />
    </g>
  </svg>
)

export const rssIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.41}
    height={11.887}
    viewBox="0 0 15.41 11.887"
  >
    <g
      data-name="Group 27205"
      transform="translate(-83.3 -80.01)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 437"
        cx={1.501}
        cy={1.501}
        r={1.501}
        transform="translate(89.504 84.453)"
      />
      <path
        data-name="Path 49029"
        d="M93.976 82.983a4.2 4.2 0 010 5.949m-5.942-.007a4.2 4.2 0 010-5.949M95.959 81a7.006 7.006 0 010 9.907m-9.907 0a7.006 7.006 0 010-9.907"
      />
    </g>
  </svg>
)

export const multipleSessionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
  >
    <g
      id="Group_27385"
      data-name="Group 27385"
      transform="translate(-439 -833)"
      stroke="currentColor"
    >
      <g id="Rectangle_11714" data-name="Rectangle 11714" transform="translate(439 833)" fill="none" strokeLinejoin="round" strokeWidth="1.4" opacity="0.886">
        <rect width={12} height={12} rx={2} stroke="none" />
        <rect x="0.7" y="0.7" width="10.6" height="10.6" rx="1.3" fill="none" />
      </g>
      <line id="Line_1551" data-name="Line 1551" x2="5.917" transform="translate(442.125 837)" fill="none" strokeLinecap="round" strokeWidth="1.2" />
      <line id="Line_1552" data-name="Line 1552" x2={4} transform="translate(442.125 839.5)" fill="none" strokeLinecap="round" strokeWidth={1} />
    </g>
  </svg>
)

export const liveOnlineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.967}
    height={11.574}
    viewBox="0 0 14.967 11.574"
  >
    <g
      data-name="radio (2)"
      transform="translate(-1.302 -3.94)"
      fill="none"
      stroke="#76777a"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 437"
        cx={1.357}
        cy={1.357}
        r={1.357}
        transform="translate(7.429 8.37)"
      />
      <path
        data-name="Path 49029"
        d="M11.663 6.85a4.071 4.071 0 010 5.761M5.909 12.6a4.071 4.071 0 010-5.761m7.674-1.909a6.785 6.785 0 010 9.594m-9.594 0a6.785 6.785 0 010-9.594"
      />
    </g>
  </svg>
)

export const archiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.676}
    height={11.773}
    viewBox="0 0 13.676 11.773"
  >
    <g
      transform="translate(.731 .7)"
      fill="none"
      stroke="#76777a"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path data-name="Path 49028" d="M11.104 7.225V0h-10v7.225" />
      <path
        data-name="Rectangle 11316"
        transform="translate(-.031 7.304)"
        d="M0 0H12.276V3.069H0z"
      />
      <path
        data-name="Line 1470"
        transform="translate(5.339 5.002)"
        d="M0 0L1.534 0"
      />
    </g>
  </svg>
)

export const cookieIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23.05}
    height={23.075}
    viewBox="0 0 23.05 23.075"
  >
    <path
      d="M13.787 13.234a1.791 1.791 0 001.267-3.051 1.791 1.791 0 00-2.533 2.533 1.723 1.723 0 001.266.518zm-2.3 5.757a1.769 1.769 0 10-1.267-.518 1.723 1.723 0 001.264.519zm7.484 1.094a1.131 1.131 0 10-.82-.331 1.114 1.114 0 00.817.331zm-3.454 6.909a11.141 11.141 0 01-4.462-.907 11.6 11.6 0 01-6.146-6.146 11.456 11.456 0 01.216-9.413 11.852 11.852 0 013.008-3.9 11.566 11.566 0 014.347-2.3 10.783 10.783 0 015.109-.187 5.219 5.219 0 00.23 2.447 5.027 5.027 0 001.221 1.954 4.952 4.952 0 001.972 1.18 5.116 5.116 0 002.418.178 3.066 3.066 0 00.633 3.152A4.24 4.24 0 0027 14.587a10.791 10.791 0 01-.59 4.75 11.51 11.51 0 01-2.4 3.944 11.9 11.9 0 01-3.771 2.706 11.149 11.149 0 01-4.725 1.007zm0-1.727a9.239 9.239 0 006.793-2.691 10.2 10.2 0 003.02-6.636 5.923 5.923 0 01-2.519-1.713 5.2 5.2 0 01-1.195-2.605 6.427 6.427 0 01-3.929-2.015 6.607 6.607 0 01-1.827-3.943 9.23 9.23 0 00-3.987.691 10.046 10.046 0 00-3.224 2.13A9.842 9.842 0 006.5 11.666a9.65 9.65 0 00-.777 3.814 9.442 9.442 0 002.85 6.937 9.442 9.442 0 006.941 2.85zm.026-9.931z"
      transform="translate(-4 -3.919)"
      fill="#fff"
    />
  </svg>
)

export const shoppingBag = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.899} height={11.954}
    viewBox="0 0 10.899 11.954"
  >
    <g transform="translate(-2.3 -1.3)">
      <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" />
      <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" />
    </g>
  </svg>
)

export const importContentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.59}
    height={11.952}
    viewBox="0 0 14.59 11.952"
  >
    <g data-name="Group 27222">
      <g
        data-name="Group 27211"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        transform="translate(-83.3 -575.3)"
      >
        <path
          data-name="Line 1624"
          transform="translate(84 581.412)"
          d="M13.003 0L0 0"
        />
        <path
          data-name="Path 49124"
          d="M86.275 576.732L84 581.276v3.957a1.319 1.319 0 001.319 1.319h10.552a1.319 1.319 0 001.319-1.319v-3.957l-2.275-4.544a1.319 1.319 0 00-1.181-.732h-6.278a1.319 1.319 0 00-1.181.732z"
        />
        <path
          data-name="Line 1625"
          transform="translate(86.638 583.914)"
          d="M0 0L0.006 0"
        />
        <path
          data-name="Line 1626"
          transform="translate(89.276 583.914)"
          d="M0 0L0.006 0"
        />
      </g>
    </g>
  </svg>
)

export const chooseFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.674}
    height={13.347}
    viewBox="0 0 14.674 13.347"
  >
    <g data-name="Group 27223">
      <g
        data-name="Group 27210"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      >
        <path
          data-name="Path 49123"
          d="M97.274 513.619a1.327 1.327 0 01-1.327 1.327h-10.62A1.327 1.327 0 0184 513.619v-9.292A1.327 1.327 0 0185.327 503h3.319l1.327 1.991h5.973a1.327 1.327 0 011.327 1.327z"
          transform="translate(-83.3 -502.3)"
        />
        <g
          data-name="Group 27201"
          transform="translate(-83.3 -502.3) translate(83.5 503)"
        >
          <path
            data-name="Line 1622"
            transform="translate(7 5)"
            d="M0 0L0 4"
          />
          <path
            data-name="Line 1623"
            transform="translate(5 7)"
            d="M0 0L4 0"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const codeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.4}
    height={15.4}
    viewBox="0 0 14.4 15.4"
  >
    <g
      data-name="Group 27202"
      transform="translate(-83.3 -430.424)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <rect
        data-name="Rectangle 11634"
        width={13}
        height={14}
        rx={2}
        transform="translate(84 431.124)"
      />
      <g data-name="Group 27160">
        <path
          data-name="Path 49119"
          d="M97.175 788.331l1.915-1.915-1.915-1.916"
          transform="translate(-4.589 -348.376)"
        />
        <path
          data-name="Path 49120"
          d="M93.005 784.5l-1.915 1.915 1.915 1.916"
          transform="translate(-4.589 -348.376)"
        />
      </g>
    </g>
  </svg>
)

export const surveyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.4}
    height={15.4}
    viewBox="0 0 13.4 15.4"
  >
    <g data-name="Group 27203" transform="translate(-83.3 -360.548)">
      <rect
        data-name="Rectangle 11634"
        width={12}
        height={14}
        rx={2}
        transform="translate(84.001 361.248) translate(-.001)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      />
      <path
        data-name="Line 1620"
        transform="translate(87.5 372.358)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        d="M5.321 0L0 0"
      />
      <path
        data-name="check (4)"
        d="M92.092 365.324l-2.878 2.878-1.308-1.308"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        style={{
          mixBlendMode: "darken",
          isolation: "isolate"
        }}
      />
    </g>
  </svg>
)

export const videoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={14.824}
    height={14.269}
    viewBox="0 0 14.8 14.3"
  >
    <g fill="currentColor">
      <path
        d="M89.2 299.2c-.1 0-.2 0-.3-.1-.2-.1-.4-.4-.4-.6V294c0-.3.1-.5.4-.6.2-.1.5-.1.7 0l3.5 2.3c.2.1.3.4.3.6s-.1.5-.3.6l-3.5 2.3h-.4zm.7-3.9v2l1.5-1-1.5-1z"
        transform="translate(-83.3 -290.424)"
      />
      <path
        d="M97.4 290.4H84c-.4 0-.7.3-.7.7v10.3c0 .4.3.7.7.7h6.3v1.2H87c-.4 0-.7.3-.7.7s.3.7.7.7h8c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-3.3v-1.2h5.8c.4 0 .7-.3.7-.7v-10.3c-.1-.4-.4-.7-.8-.7zm-.7 10.3h-12v-8.9h12v8.9z"
        transform="translate(-83.3 -290.424)"
      />
    </g>
  </svg>
)

export const videoCameraIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.906}
    height={10.4}
    viewBox="0 0 15.906 10.4"
  >
    <g data-name="Group 27220">
      <g data-name="Group 27216">
        <g
          data-name="video (1)"
          transform="translate(-82.068 -718.3) translate(-129.232 28) translate(211 685.782)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.4}
        >
          <path
            data-name="Path 49126"
            d="M15.506 6.306l-4.616 3.3 4.616 3.3z"
          />
          <rect
            data-name="Rectangle 11636"
            width={9}
            height={9}
            rx={2}
            transform="translate(1 5.218)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const musicIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.427}
    height={13.427}
    viewBox="0 0 13.427 13.427"
  >
    <g data-name="Group 27219">
      <g data-name="Group 27215">
        <g
          transform="translate(-83.882 -646.273) translate(5.582 -7) translate(0 5.973) translate(79 648)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.4}
          data-name="Group 27214"
        >
          <path
            data-name="Path 49125"
            d="M4.009 10.022V1.336L12.027 0v8.686"
          />
          <circle
            data-name="Ellipse 455"
            cx={2}
            cy={2}
            r={2}
            transform="translate(0 8.027)"
          />
          <ellipse
            data-name="Ellipse 456"
            cx={2}
            cy={1.5}
            rx={2}
            ry={1.5}
            transform="translate(8 7.027)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const clipBoardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.203}
    height={12.404}
    viewBox="0 0 10.203 12.404"
  >
    <g data-name="Group 27227">
      <g
        data-name="Group 27206"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        transform="translate(-83.3 -221.3)"
      >
        <path
          data-name="Path 49073"
          d="M90.6 223.1h1.1a1.1 1.1 0 011.1 1.1v7.7a1.1 1.1 0 01-1.1 1.1h-6.6a1.1 1.1 0 01-1.1-1.1v-7.7a1.1 1.1 0 011.1-1.1h1.1"
        />
        <rect
          data-name="Rectangle 11504"
          width={4.388}
          height={2.194}
          rx={1}
          transform="translate(86.194 222)"
        />
      </g>
    </g>
  </svg>
)

export const testIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.676}
    height={15.52}
    viewBox="0 0 12.676 15.52"
  >
    <g data-name="Group 27229">
      <g
        data-name="Group 27213"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        transform="translate(-83.35 -150.226)"
      >
        <path
          data-name="Path 49054"
          d="M91.11 150.876h-5.688A1.422 1.422 0 0084 152.298v11.378a1.422 1.422 0 001.422 1.42h8.532a1.422 1.422 0 001.422-1.42v-8.534z"
        />
        <path data-name="Path 49055" d="M91.109 150.876v4.266h4.266" />
        <path
          data-name="Line 1473"
          transform="translate(86.688 158.985)"
          d="M6 0L0 0"
        />
        <path
          data-name="Line 1474"
          transform="translate(86.688 161.985)"
          d="M6 0L0 0"
        />
        <path data-name="Path 49056" d="M88.266 155.852h-1.422" />
      </g>
    </g>
  </svg>
)

export const usersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.459}
    height={13.784}
    viewBox="0 0 16.459 13.784"
  >
    <g data-name="Group 27221">
      <g
        transform="translate(-83.3 -787.569) translate(83 785.332)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        data-name="Group 27218"
      >
        <path
          data-name="Path 49127"
          d="M11.952 15.321v-1.369a2.738 2.738 0 00-2.738-2.738H3.738A2.738 2.738 0 001 13.952v1.369"
        />
        <circle
          data-name="Ellipse 457"
          cx={2.5}
          cy={2.5}
          r={2.5}
          transform="translate(4 3.321)"
        />
        <path
          data-name="Path 49128"
          d="M16.06 15.321v-1.369a2.738 2.738 0 00-2.054-2.649"
        />
        <path
          data-name="Path 49129"
          d="M11.268 3.089a2.738 2.738 0 010 5.3"
        />
      </g>
    </g>
  </svg>
)

export const addFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.4}
    height={21.4}
    viewBox="0 0 17.4 21.4"
  >
    <g
      transform="translate(-83.3 -861.3) translate(80 860)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      data-name="Group 27217"
    >
      <path
        data-name="Path 49130"
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
      />
      <path data-name="Path 49131" d="M14 2v6h6" />
      <path data-name="Line 1627" transform="translate(12 12)" d="M0 6L0 0" />
      <path data-name="Line 1628" transform="translate(9 15)" d="M0 0L6 0" />
    </g>
  </svg>
)

export const unsubcribedMessageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.211}
    height={14}
    viewBox="0 0 16.211 14"
  >
    <path
      d="M11.368 14.208l-6.263-4v8.474h7.111a4.149 4.149 0 00.166 1.105H5.105a1.047 1.047 0 01-.774-.341A1.071 1.071 0 014 18.684V9.105a1.071 1.071 0 01.332-.764A1.047 1.047 0 015.105 8h12.527a1.169 1.169 0 011.105 1.105v5.361a2.983 2.983 0 00-.525-.212q-.322-.1-.58-.157v-3.886zm0-1.179l6.263-3.924H5.105zM16.766 22a3.338 3.338 0 01-2.441-.995 3.292 3.292 0 01-1-2.432 3.353 3.353 0 011-2.45 3.447 3.447 0 014.882 0 3.353 3.353 0 011 2.45 3.292 3.292 0 01-1 2.432 3.338 3.338 0 01-2.441.995zm-.608-2.763h.847v-2.948h-.847zm-11.053-.553z"
      transform="translate(-4 -8)"
    />
  </svg>
)

export const exclamatoryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.4}
    height={16.4}
    viewBox="0 0 16.4 16.4"
  >
    <circle id="Ellipse_63" data-name="Ellipse 63" cx="7.5" cy="7.5" r="7.5" transform="translate(0.7 0.7)" fill="#fff" stroke="#e30002" strokeWidth="1.4" />
    <path id="Path_59" data-name="Path 59" d="M822.5,583.685v4.54" transform="translate(-814.216 -579.681)" fill="none" stroke="#e30002" strokeLinecap="round" strokeWidth="2" />
    <path id="Path_60" data-name="Path 60" d="M822.5,583.725v-.04" transform="translate(-814.216 -572.248)" fill="none" stroke="#e30002" strokeLinecap="round" strokeWidth="2.4" />
  </svg>
)

export const learnerEdiIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width={20}
    height={20}
    x={0}
    y={0}
    viewBox="0 0 492.49284 492"
    style={{ top: '-4px', enableBackground: 'new 0 0 512 512' }}
    xmlSpace="preserve"
  >
    <g>
      <path xmlns="http://www.w3.org/2000/svg" d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0" fill="#2d71fd" data-original="#000000" />
      <path xmlns="http://www.w3.org/2000/svg" d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0" fill="#2d71fd" data-original="#000000" />
    </g>
  </svg>
)

export const learnerTrashIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={12}
    height={12}
    x={0}
    y={0}
    viewBox="0 0 512 512"
    style={{ enableBackground: 'new 0 0 512 512' }}
    xmlSpace="preserve"
  >
    <g>
      <g xmlns="http://www.w3.org/2000/svg">
        <path d="m424 64h-88v-16c0-26.51-21.49-48-48-48h-64c-26.51 0-48 21.49-48 48v16h-88c-22.091 0-40 17.909-40 40v32c0 8.837 7.163 16 16 16h384c8.837 0 16-7.163 16-16v-32c0-22.091-17.909-40-40-40zm-216-16c0-8.82 7.18-16 16-16h64c8.82 0 16 7.18 16 16v16h-96z" fill="#ff4848" data-original="#000000" />
        <path d="m78.364 184c-2.855 0-5.13 2.386-4.994 5.238l13.2 277.042c1.22 25.64 22.28 45.72 47.94 45.72h242.98c25.66 0 46.72-20.08 47.94-45.72l13.2-277.042c.136-2.852-2.139-5.238-4.994-5.238zm241.636 40c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16zm-80 0c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16zm-80 0c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16z" fill="#ff4848" data-original="#000000" />
      </g>
    </g>
  </svg>
)

export const orderSuccess = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="82"
    viewBox="0 0 82 82"
  >
    <g dataName="Ellipse 107" transform="translate(10 10)" fill="#8ac796" stroke="rgba(138,199,150,0.2)" strokeWidth="10">
      <circle cx="31" cy="31" r="31" stroke="none"></circle>
      <circle cx="31" cy="31" r="36" fill="none"></circle>
    </g>
    <path dataName="Path 82" d="M23066.023-21824.447l6.83,6.83,15.875-15.875" transform="translate(-23036.412 21868.469)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"></path>
  </svg>
)

export const rightArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.22}
    height={15.397}
    viewBox="0 0 7.22 15.397"
  >
    <path
      data-name="Path 49063"
      d="M1.402 1.402l4.818 6.3-4.818 6.294"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
)

export const linkedinIcon = (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-271 283.9 256 235.1"
  >
    <path d="M-264.4 359.3H-214.49999999999997V519H-264.4z" />
    <path d="M-240.5 283.9c-18.4 0-30.5 11.9-30.5 27.7 0 15.5 11.7 27.7 29.8 27.7h.4c18.8 0 30.5-12.3 30.4-27.7-.4-15.8-11.7-27.7-30.1-27.7zM-78.2 357.8c-28.6 0-46.5 15.6-49.8 26.6v-25.1h-56.1c.7 13.3 0 159.7 0 159.7h56.1v-86.3c0-4.9-.2-9.7 1.2-13.1 3.8-9.6 12.1-19.6 27-19.6 19.5 0 28.3 14.8 28.3 36.4V519h56.6v-88.8c0-49.4-27.8-72.4-63.3-72.4z" />
  </svg>
)

export const shareIcon = (
  <svg
    width="800px"
    height="800px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x={-2.4}
      y={-2.4}
      width={28.8}
      height={28.8}
      rx={14.4}
      fill="#76777A"
      strokeWidth={0}
    />
    <path
      d="M9.611 12.4l1.207 6.135c.228 1.159 1.785 1.39 2.338.347l5.865-11.04c.227-.426.18-.898-.047-1.258M9.61 12.4L5.226 8.155C4.416 7.371 4.972 6 6.1 6h11.814c.463 0 .844.24 1.06.584M9.612 12.4l9.363-5.816m.081-.05l-.081.05"
      stroke="#fcfcfc"
      strokeWidth={2}
    />
  </svg>
);

export const clearBtnIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
  >
    <g data-name="close" transform="translate(-1137 -293)">
      <rect
        data-name="Rectangle 753"
        width={26}
        height={26}
        rx={13}
        transform="translate(1137 293)"
        fill="currentColor"
      />
      <g data-name="Group 17821" fill="none" stroke="#13171f">
        <path
          data-name="Path 21632"
          d="M0 0v8.41"
          transform="translate(1147.027 303.027) rotate(45 2.974 7.179)"
        />
        <path
          data-name="Path 21633"
          d="M0 0v8.41"
          transform="translate(1147.027 303.027) rotate(135 1.742 4.205)"
        />
      </g>
    </g>
  </svg>
);

export const bundleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-stack"
    viewBox="0 0 16 16"
  >
    <path d="M14.12 10.163l1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 01-.534 0L.165 11.555a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 01.534 0l7.568 3.784a.3.3 0 010 .535L8.267 8.165a.598.598 0 01-.534 0L.165 4.382a.299.299 0 010-.535L7.733.063z" />
    <path d="M14.12 6.576l1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 01-.534 0L.165 7.968a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z" />
  </svg>
);

export const crossIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.828}
    height={14.828}
    viewBox="0 0 14.828 14.828"
  >
    <g data-name="Group 27702">
      <g
        transform="translate(-17.586 -123.586) translate(13 119) translate(6 6)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        data-name="Group 27685"
      >
        <path data-name="Line 1542" d="M12 0L0 12" />
        <path data-name="Line 1543" d="M0 0L12 12" />
      </g>
    </g>
  </svg>
);

export const tickIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={15.241} height={10.948} viewBox="0 0 15.241 10.948">
    <path d="M16.413 6l-8.534 8.534L4 10.655" transform="translate(-2.586 -4.586)" fill="none" stroke="#6F75BC" strokeWidth="2" />
  </svg>
);

export const telIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
  >
    <path
      fill="currentColor"
      d="M2.505.541a1.728 1.728 0 0 0-.681.383C1.567 1.145.645 2.084.495 2.277c-.61.78-.62 1.991-.03 3.555.72 1.911 2.067 3.847 3.773 5.42 2.352 2.168 5.502 3.57 7.123 3.177.241-.058.64-.243.824-.383.185-.14 1.421-1.408 1.536-1.575.214-.309.296-.722.214-1.072-.093-.39-.123-.426-1.313-1.618-1.2-1.2-1.239-1.23-1.635-1.313a1.317 1.317 0 0 0-.944.17c-.07.043-.41.352-.751.691l-.621.613-.2-.104c-.49-.254-.85-.498-1.389-.94a13.002 13.002 0 0 1-1.75-1.808c-.309-.405-.763-1.151-.765-1.252 0-.02.213-.244.473-.498.547-.533.763-.782.886-1.017.153-.298.183-.676.076-.987-.107-.318-.21-.438-1.255-1.485C3.713.817 3.555.68 3.26.579a1.535 1.535 0 0 0-.755-.038Zm.634.768c.077.044.514.457 1.102 1.048 1.064 1.066 1.105 1.115 1.102 1.397 0 .249-.065.336-.78 1.05-.36.358-.675.689-.696.736-.033.057-.041.136-.033.27.008.164.03.227.197.558.377.75.875 1.408 1.698 2.25.817.837 1.632 1.46 2.472 1.893.298.153.355.175.492.172.093 0 .191-.02.249-.05.052-.027.39-.344.752-.702.464-.462.691-.667.779-.706a.656.656 0 0 1 .528 0c.164.082 2.097 2.013 2.182 2.183.046.09.065.172.065.29 0 .281-.057.357-.834 1.137-.768.77-.84.823-1.25.916-.396.087-1.06.016-1.733-.183-1.025-.304-2.403-1.031-3.538-1.868-2.185-1.608-4.06-4.066-4.84-6.338C.68 4.282.64 3.508.924 2.934c.088-.184.17-.277.739-.853.35-.356.686-.679.743-.72.247-.17.498-.188.733-.052Z"
    />
  </svg>
)

export const zipIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-file-zip"
  >
    <path d="M6.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599zm2 0h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243z" />
    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm5.5-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9v1H8v1h1v1H8v1h1v1H7.5V5h-1V4h1V3h-1V2h1z" />
  </svg>
)

export const pdfIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-file-pdf"
  >
    <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
    <path d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.6 11.6 0 0 0-1.997.406 11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.244.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 5.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
  </svg>
)

export const downloadBaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-download"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
  </svg>
)

export const arrow45Deg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    className="bi bi-arrow-up-right"
  >
    <path
      fillRule="evenodd"
      d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z"
    />
  </svg>
)

export const plusIcon = (
<svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-plus"
  >
    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
  </svg>
)